import { Channel } from '@/types'
import { create } from 'zustand'

// Define the possible view states
export const VIEW_STATES = {
  FEED: 'feed',
  INFO: 'info',
  FULL_SCREEN: 'fullScreen',
  TEXT: 'text',
}

// Define the store's state
type ContentChannelState = {
  channelContent: Channel
  setChannelContent: (value: Channel) => void
  currentView: string
  setView: (view: string) => void
  isMuted: boolean
  setIsMuted: (value: boolean) => void
  currentPlayingVideoUid: string | null
  setCurrentPlayingVideoUid: (uid: string | null) => void
  textTileUid: string | null
  setTextTileUid: (uid: string | null) => void
}

// Create the store
export const useContentChannelStore = create<ContentChannelState>((set) => ({
  channelContent: {
    actions: [],
    assets: {
      event_name: '',
      badge: '',
    },
    main: [],
    tiles: [],
    uid: '',
    live: false,
    doomscroll: false,
  },
  setChannelContent: (value) =>
    set({
      channelContent: {
        ...value,
        main: value.main.filter((c) => c.enabled !== false),
        tiles: value.tiles.filter((t) => t.enabled),
        actions: value.actions.filter((a) => a.enabled),
      },
    }),
  currentView: VIEW_STATES.FEED,
  setView: (view) => set({ currentView: view }),
  isMuted: localStorage.getItem('iframe_mode') === 'true',
  setIsMuted: (value) => set({ isMuted: value }),
  currentPlayingVideoUid: null,
  setCurrentPlayingVideoUid: (uid) => set({ currentPlayingVideoUid: uid }),
  textTileUid: null,
  setTextTileUid: (uid) => set({ textTileUid: uid }),
}))
